module.exports = __webpack_public_path__ + "static/media/Elliptical.d0329c93.svg";